var CONTENT_TYPE = {
  BANNER: 'banner',
  DROPDOWN: 'dropdown'
};
var LANG_VARIANT = {
  LARGE: 'large',
  SMALL: 'small'
};
var SIGN_IN_VARIANT = {
  GOLD: 'gold',
  OUTLINE: 'outline'
};
var TAB_VARIANT = {
  LINE: 'line',
  NO_LINE: 'no-line'
};
var MOBILE_MENU_VARIANT = {
  ACCORDION: 'accordion',
  OVERLAY: 'overlay'
};

export { CONTENT_TYPE, LANG_VARIANT, MOBILE_MENU_VARIANT, SIGN_IN_VARIANT, TAB_VARIANT };
